var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 7.33318V6.41648C7.08125 6.31426 7.67112 5.61207 7.733 5.06342C7.89525 5.05104 8.15008 4.90208 8.22525 4.31401C8.26558 3.99821 8.10517 3.82083 8.008 3.76491C8.008 3.76491 8.25 3.30518 8.25 2.75011C8.25 1.63724 7.81321 0.687529 6.875 0.687529C6.875 0.687529 6.54913 0 5.5 0C3.55575 0 2.75 1.24718 2.75 2.75011C2.75 3.25614 2.992 3.76491 2.992 3.76491C2.89483 3.82083 2.73442 3.99867 2.77475 4.31401C2.84992 4.90208 3.10475 5.05104 3.267 5.06342C3.32888 5.61207 3.91875 6.31426 4.125 6.41648V7.33318C3.66667 8.70824 0 7.79153 0 11H11C11 7.79153 7.33333 8.70824 6.875 7.33318Z",
    fill: "#99A8B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.e8999113735f6f7c5d20f4764eebaf55.svg";
export { ForwardRef as ReactComponent };